import React from 'react';

import * as S from './CaptivateBannerGalleryWithVideo.styles';
import HappyLeftArrowTransparent from '@stencil/icons/src/HappyLeftArrowTransparent/HappyLeftArrowTransparent';

const ImageItem = ({
  id = null,
  title,
  count,
  imageAlt,
  imageUrl,
  onImageClick,
  isSeoPage,
  imageHeight,
  marginBottom,
  keyName,
  tagName,
}) => {
  return (
    <S.ImageItemWrapper
      isSeoPage={isSeoPage}
      imageHeight={imageHeight}
      marginBottom={marginBottom}
      onClick={e => {
        e.stopPropagation();
        onImageClick(keyName, tagName);
      }}
    >
      <img src={imageUrl} alt={imageAlt} />
      <S.ItemInfoWrapper>
        <S.InfoLeftSection>
          <p>
            <strong>
              {title}
              {count ? `(${count})` : null}
            </strong>
          </p>
        </S.InfoLeftSection>
        <S.InfoRightSection>
          <HappyLeftArrowTransparent />
        </S.InfoRightSection>
      </S.ItemInfoWrapper>
    </S.ImageItemWrapper>
  );
};

export default ImageItem;
